module.exports = __webpack_public_path__ + "img/active2021.f847cc81.png";